<template>
    <div class="material-market" :class="{ 'fixed-header': isHeaderFixed }">
        <!-- 顶部导航 -->
        <div class="header">
            <div class="logo-container">
                <img src="./images/img_logo.png" alt="" class="logo"/>
                <span class="logo-text">素材市场</span>
                <div class="sub-title">投标有我，素材无忧</div>
            </div>
            <!-- 搜索区域移动到顶部导航栏，根据滚动距离判断显隐 -->
            <div class="search-box-header" v-show="isHeaderFixed">
                <el-autocomplete
                    ref="searchInput"
                    v-model="searchKeyword"
                    :fetch-suggestions="querySearchAsync"
                    placeholder="请输入关键字"
                    @focus="showHotTags = true"
                    @blur="handleSearchBlur"
                    class="search-input"
                    size="small"
                    clearable
                    :trigger-on-focus="false"
                    :highlight-first-item="true"
                    popper-class="search-box-header-popper"
                    @keyup.enter.native="handleSearch(searchKeyword)"
                >
                    <!-- 自定义建议项模板，支持HTML内容 -->
                    <template slot-scope="{ item }">
                        <div v-if="item.label" v-html="item.label"></div>
                        <div v-else>{{ item.value }}</div>
                    </template>
                    <template #prefix>
                        <i class="el-icon-search"></i>
                    </template>
                    <template #suffix>
                        <el-button @click="handleSearch(searchKeyword)">搜索</el-button>
                    </template>
                </el-autocomplete>

                <!-- 搜索历史下拉框 -->
                <div class="hot-tags-dropdown" v-show="showHotTags && searchHistory.length > 0">
                    <div class="search-history">
                        <div class="history-title">
                            <span>搜索历史</span>
                            <span class="clear-history" @click="clearSearchHistory">
                                <i class="el-icon-delete"></i>
                                清空所有记录
                            </span>
                        </div>
                        <div class="history-items">
                            <div
                                class="history-item"
                                v-for="(item, index) in searchHistory"
                                :key="'history-' + index"
                                @click="selectHotTag(item)"
                            >
                                <span>{{ item }}</span>
                                <i class="el-icon-close" @click.stop="removeSearchHistory(item)"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="header-right">
                <div class="upload-slogan">
                    上传文档，享高额收益！
                    <a href="javascript:" @click="toOpenMaster">
                        了解详情
                    </a>
                </div>
                <div class="user-info" @click.stop="toggleUserDropdown">
                    <img :src="userAvatar" class="avatar" alt="用户头像"/>
                    <span class="username">{{ userInfo.name }}</span>
                    <span class="vip-tag" v-if="userInfo.isVip">VIP</span>
                    <i :class="[showUserDropdown ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"></i>
                    <!-- 用户下拉菜单 -->
                    <div class="user-dropdown" v-if="showUserDropdown" v-click-outside="closeUserDropdown"
                         @click.stop="() => false">
                        <div class="dropdown-header">
                            <div class="user-account">
                                <span>个人账号：{{ userInfo.account }}</span>
                                <span  class="personal-center-link" @click="toUserCenter">
                                    个人中心 <i class="el-icon-arrow-right"></i>
                                </span>
                            </div>
                        </div>

                        <!-- 添加开通会员区域 -->
                        <div class="vip-activate" v-if="!userInfo.isVip">
                            <div class="vip-activate-title">开通会员</div>
                            <div class="vip-activate-desc">低至 6 折，专属特惠！</div>
                            <el-button type="warning" round class="activate-btn" @click.stop="activateVip()">
                                立即开通
                            </el-button>
                        </div>
                        <div
                            class="swiper swiper-container vip-swiper"
                            :class="{
                                'has-pagination': vips.length > 1
                            }"
                            ref="vip-swiper"
                            v-else
                        >
                            <div class="swiper-wrapper">
                                <div
                                    class="vip-info-box swiper-slide"
                                    v-for="vip in vips"
                                    :class="{ 'zx-vip': vip.title.indexOf('尊享会员') !== -1 }"
                                    :key="vip.guid"
                                >
                                    <div class="vip-info">
                                        <div class="vip-badge">
                                            <img :src="vip.icon" alt=""/>
                                            <span>{{ vip.title }}</span>
                                            <span class="vip-expire">有效期至{{ vip.expiredate }}</span>
                                        </div>
                                        <el-button
                                            size="mini"
                                            round
                                            type="warning"
                                            @click.stop="activateVip(vip.type)"
                                            class="renew-btn"
                                        >续费
                                        </el-button
                                        >
                                    </div>

                                    <div class="vip-benefits">
                                        <div class="benefit-item" v-for="(equity, index) in vip.equitys" :key="index">
                                            <div class="benefit-value">
                                                <span>{{ equity.value }}</span>
                                                {{ equity.unit }}
                                            </div>
                                            <div class="benefit-name">
                                                {{ equity.label }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-pagination"></div>
                        </div>

                        <div class="user-statistics">
                            <div class="collection-resources">
                                <div class="user-collection">
                                    <span class="value" @click="toResources('collected')">
                                        {{ userInfo.collection }}
                                    </span>
                                    <label>我的收藏</label>
                                </div>

                                <div class="user-resources">
                                    <span class="value" @click="toResources('payed')">
                                        {{ userInfo.resources }}
                                    </span>
                                    <label>我的资源</label>
                                </div>
                            </div>

                            <div class="user-stats" v-if="userInfo.isMaster">
                                <div class="stat-today">
                                    今日
                                    <span class="highlight">
                                        + {{ userInfo.todayEarnings }}
                                    </span>
                                </div>
                                <div class="stat-total">
                                    累计收益
                                    <span class="total-value">
                                        {{ userInfo.cumulativeIncome }}
                                    </span>
                                    元
                                </div>
                                <div class="user-income" @click="toMyEarnings">
                                    <span>我的收益</span>
                                    <i class="el-icon-arrow-right"></i>
                                </div>
                            </div>

                            <div class="user-master" @click="toOpenMaster" v-else>
                                <div>
                                    创享达人认证
                                </div>
                                <p>
                                    共享素材，月入过万不是梦
                                </p>
                                <span>了解详情</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 左侧导航 -->
        <div class="sidebar">
            <div class="menu-list">
                <div
                    class="menu-item"
                    v-for="item in menuList"
                    :class="{
                        active: isActiveMenu(item.pathName)
                    }"
                    @click="menuItemClick(item.pathName)"
                    :key="item.title"
                >
                    <img :src="item.icon" alt=""/>
                    <span>{{ item.title }}</span>
                </div>
            </div>

            <div class="category-title">素材库</div>

            <div class="category-menu" v-for="category in categoryMenuList" :key="category.guid">
                <div class="category-item">
                    <img :src="category.icon" alt=""/>
                    <span>{{ category.label }}</span>
                </div>
                <div class="sub-category">
                    <div
                        class="sub-category-item"
                        v-for="(child, index) in category.children"
                        v-show="index < 5"
                        :key="child.guid"
                        @click="categoryItemCLick(child.value, category.value)"
                    >
                        {{ child.label }}
                    </div>
                    <p @click="categoryItemCLick('', category.value)">
                        查看全部 {{ category.children.length }} 个分类 <i class="el-icon-arrow-right"></i>
                    </p>
                </div>
            </div>
        </div>

        <!-- 主体内容 -->
        <div class="main-content" :class="{ 'header-fixed': isHeaderFixed }">
            <!-- 右侧内容区 -->
            <div class="content-area">
                <!-- 使用路由视图替换原有内容 -->
                <router-view ref="viewer" @search="handleSearch"></router-view>
            </div>
        </div>

        <!-- 会员购买弹窗 -->
        <membership-dialog-iframe v-if="membershipDialog.show"/>

        <!-- 用户中心 -->
        <user-center-dialog-iframe
            v-if="userCenterDialog.show"
            @close="userCenterDialog.show = false"
        ></user-center-dialog-iframe>

        <!-- 素材详情-->
        <material-detail-dialog v-if="materialDetailDialog.show"/>

        <!-- 新用户专属-->
        <el-dialog
            :visible.sync="newUserExclusiveDialog.show"
            title=""
            :show-close="true"
            :close-on-press-escape="false"
            :close-on-click-modal="false"
            append-to-body
            custom-class="new-user-exclusive-dialog"
        >
            <div class="new-user-exclusive-container">
                <img src="./images/new_user_exclusive.png" alt="">
                <a href="javascript:" @click="getNewUserExclusive" class="get-btn"></a>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import MembershipDialogIframe from './components/membership-dialog-iframe.vue';
import MaterialDetailDialog from './components/material-detail-dialog.vue';
import UserCenterDialogIframe from './components/user-center-dialog-iframe.vue';
import {mapGetters, mapActions} from 'vuex'; // 修改这里的引入方式
import DEFAULT_AVATAR from '@/views/material-market/images/img_user.png';
import ICON_YYZX from '@/views/material-market/images/icon_yyzx.png';
import ICON_WDZY from '@/views/material-market/images/icon_wdzy.png';
import ICON_CXDR from '@/views/material-market/images/icon_cxdr.png';
import ICON_GCL from '@/views/material-market/images/icon_gcl.png';
import ICON_FWL from '@/views/material-market/images/icon_fwl.png';
import ICON_HWL from '@/views/material-market/images/icon_hwl.png';
import ICON_VIP from '@/views/material-market/images/icon_vip.png';
import ICON_VIP2 from '@/views/material-market/images/icon_vip2.png';
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
import {getMaterialTypesData, createGuid} from '@/util/util';

export default {
    name: 'MaterialMarket',
    components: {
        MembershipDialogIframe,
        MaterialDetailDialog,
        UserCenterDialogIframe
    },
    data() {
        return {
            searchKeyword: '',
            showUserDropdown: false,
            isHeaderFixed: false,
            showHotTags: false,
            menuList: [
                {
                    title: '首页推荐',
                    icon: ICON_YYZX,
                    pathName: 'MaterialMarket'
                },
                {
                    title: '我的资源',
                    icon: ICON_WDZY,
                    pathName: 'MyResourcesHome'
                },
                {
                    title: '创享达人',
                    icon: ICON_CXDR,
                    pathName: 'TritonMasterHome'
                }
            ],
            categoryMenuList: [],
            searchHistory: [],
            searchSuggestions: [],
            vipSwiper: null,
            vipSwiperIndex: 0,
            timer: false,
            userCenterDialog: {
                show: false
            },
            newUserExclusiveDialog: {
                show: false
            }
        };
    },
    computed: {
        ...mapGetters(['userInfo', 'membershipDialog', 'materialDetailDialog', 'platform']),
        userAvatar() {
            return this.userInfo.avatar || DEFAULT_AVATAR;
        },
        vips() {
            if (!this.userInfo.vips || !Array.isArray(this.userInfo.vips)) {
                return [];
            }
            return this.userInfo.vips.map((e) => ({
                ...e,
                icon: e.title.indexOf('尊享会员') !== -1 ? ICON_VIP2 : ICON_VIP
            }));
        }
    },
    created() {
        this.setPlatform(
            this.$route.query.platform
        )
    },
    mounted() {
        this.searchHistory = JSON.parse(localStorage.getItem('MATERIAL_MARKET_SEARCH_HISTORY')) || [];

        // 监听页面滚动事件
        window.addEventListener('scroll', this.handleScroll);

        // 初始化搜索框显示状态
        this.handleScroll();

        // 用户信息
        this.getUserInfo();

        // 判断用户是否有领取vip权限
        this.checkHasbeenMaterialVip();

        // 素材库菜单
        this.getMaterialLibrary();
    },
    beforeDestroy() {
        // 移除滚动事件监听
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        ...mapActions(['getUserInfo', 'openMembershipDialog', 'setPlatform']),
        // 处理页面滚动
        handleScroll() {
            this.isHeaderFixed = window.scrollY > 0;
            if (!this.isHeaderFixed && this.$refs.searchInput) {
                this.$refs.searchInput.suggestions = [];
            }
        },
        initVipSwiper() {
            let self = this;
            this.vipSwiper && this.vipSwiper.destroy();
            this.vipSwiper = new Swiper(this.$refs['vip-swiper'], {
                spaceBetween: 12,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                initialSlide: this.vipSwiperIndex,
                on: {
                    slideChangeTransitionEnd: function () {
                        self.vipSwiperIndex = this.activeIndex;
                    }
                }
            });
        },
        // 自动补全搜索建议
        querySearchAsync(queryString, callback) {
            this.$Api
                .getAutoComplete({
                    searchtext: this.searchKeyword
                })
                .then((data) => {
                    this.searchSuggestions = data.list.map(({value}) => {
                        // 如果有搜索关键词，则将其在文本中高亮显示为红色
                        if (this.searchKeyword && this.searchKeyword.trim() !== '') {
                            const regex = new RegExp(this.searchKeyword, 'gi');
                            const highlightedText = value.replace(
                                regex,
                                (match) => `<span style="color: red;">${match}</span>`
                            );
                            return {
                                value,
                                label: highlightedText
                            };
                        } else {
                            return {
                                value
                            };
                        }
                    });
                    callback(this.searchSuggestions);
                });
        },
        // 处理搜索框失焦
        handleSearchBlur() {
            // 延迟关闭热门标签下拉框，以便点击标签生效
            setTimeout(() => {
                this.showHotTags = false;
            }, 200);
        },
        // 选择热门标签
        selectHotTag(tag) {
            this.searchKeyword = tag;
            this.showHotTags = false;
            this.handleSearch();
        },
        // 清除搜索历史
        clearSearchHistory() {
            this.searchHistory = [];
            this.setSearchHistory();
        },
        // 删除搜索历史
        removeSearchHistory(data) {
            this.searchHistory = this.searchHistory.filter((item) => item !== data);
            this.setSearchHistory();
        },
        setSearchHistory() {
            localStorage.setItem('MATERIAL_MARKET_SEARCH_HISTORY', JSON.stringify(this.searchHistory));
        },
        // 切换用户下拉菜单
        toggleUserDropdown() {
            this.showUserDropdown = !this.showUserDropdown;
            if (this.showUserDropdown) {
                this.$nextTick(() => {
                    this.initVipSwiper();
                });
            }
        },
        // 关闭用户下拉菜单
        closeUserDropdown() {
            this.showUserDropdown = false;
        },
        // 搜索方法
        handleSearch(keyword) {
            if (!keyword) {
                keyword = this.searchKeyword;
            }
            this.searchHistory.push(keyword);
            this.searchHistory = [...new Set(this.searchHistory)];
            this.setSearchHistory();

            // 将搜索关键词添加到搜索历史
            if (keyword && !this.searchHistory.includes(keyword)) {
                this.searchHistory.unshift(keyword);
                // 限制历史记录数量
                if (this.searchHistory.length > 10) {
                    this.searchHistory.pop();
                }

                // 更新自动补全数据
                this.initAutoCompleteData();
            }

            // 跳转到Info路由，并传递搜索关键词
            if (keyword) {
                this.$Api
                    .setApplicationCenterHotKeywprds({
                        keyword,
                        userguid: this.userInfo.userguid
                    })
                    .then(() => {
                        this.$router.push({
                            name: 'ApplicationCenterInfo',
                            query: {keyword}
                        });

                        // 关闭热门标签下拉框
                        this.showHotTags = false;
                    });
            }
        },
        isActiveMenu: function (name) {
            return this.$route.meta.activeMenuName === name;
        },
        menuItemClick: function (name) {
            name &&
            this.$router.push({
                name
            });
        },
        // 素材库菜单
        getMaterialLibrary: function () {
            this.$Api.getMaterialTypes().then((data) => {
                let list = getMaterialTypesData(data);
                this.categoryMenuList = list.map((e) => {
                    let {label} = e;
                    let icon = '';
                    if (label === '工程类') {
                        icon = ICON_GCL;
                    } else if (label === '服务类') {
                        icon = ICON_FWL;
                    } else {
                        icon = ICON_HWL;
                    }
                    return {
                        icon,
                        ...e
                    };
                });
            });
        },
        // 开通VIP会员
        activateVip() {
            this.openMembershipDialog();
            this.closeUserDropdown(); // 关闭用户下拉菜单
        },
        // 素材库目录点击
        categoryItemCLick(typecode = '', parenttypecode = '') {
            const currentRoute = this.$route;
            if (currentRoute.name === 'ApplicationCenterInfo') {
                this.$router.replace({
                    name: 'ApplicationCenterInfo',
                    query: {
                        parenttypecode,
                        typecode
                    }
                });
            } else {
                // 直接跳转到目标路由
                this.$router.push({
                    name: 'ApplicationCenterInfo',
                    query: {
                        parenttypecode,
                        typecode
                    }
                });
            }
        },
        // 跳转个人中心
        toUserCenter() {
            if (this.platform === 'DesktopApp') {
                this.userCenterDialog.show = true;
            } else {
                window.parent.postMessage({
                    type: "utilBridge",
                    method: "accountManage",
                    params: {},
                    callbackId: createGuid()
                }, "*");
            }
        },
        // 开通达人
        toOpenMaster() {
            this.$router.push({
                name: 'TritonMasterHome'
            });
        },
        // 我的收益
        toMyEarnings() {
            this.$router.push({
                name: 'TritonMasterHome'
            });
        },
        // 我的资源
        toResources(consumerule = 'payed') {
            if (this.$refs.viewer.handleCategory) {
                this.$refs.viewer.handleCategory({
                    value: consumerule
                })
            } else {
                this.$router.push({
                    name: 'MyResourcesHome',
                    query: {
                        consumerule
                    }
                });
            }
        },
        checkHasbeenMaterialVip() {
            this.$Api.checkHasbeenMaterialVip(
                {
                    userguid: this.userInfo.userguid,
                }
            ).then(data => {
                if (!data.checkresult) {
                    this.newUserExclusiveDialog.show = true;
                }
            })
        },
        getNewUserExclusive() {
            this.$Api.getEpFreeGivingCommodity({
                moduletype: 'MATERV',
                areacode: '110100'
            }, {
                showLoading: true
            }).then(data => {
                if (data.length) {
                    this.$Api.createCommonOrder({
                        userguid: this.userInfo.userguid,
                        paymodule: data[0].modulecode,
                        paymoduletype: data[0].productcode,
                        price: 0,
                        epinvoiceisneed: '0',
                        remark: '',
                        machineinfo: '',
                    }, {
                        showLoading: true
                    }).then(data => {
                        this.$Api.freeActMaterialVip({
                            userguid: this.userInfo.userguid,
                            orderguid: data.orderguid,
                        }, {
                            showLoading: true
                        }).then(() => {
                            this.$message({
                                type: 'success',
                                message: '领取成功！'
                            });
                            this.getUserInfo()
                        }).catch(() => {
                            this.getUserInfo()
                        })
                    })
                } else {
                    this.$message({
                        type: 'error',
                        message: '系统出现问题，请联系管理员！'
                    });
                }
            })
            this.newUserExclusiveDialog.show = false;
        }
    },
    directives: {
        // 点击外部关闭指令
        clickOutside: {
            bind(el, binding) {
                const handler = (e) => {
                    if (el.contains(e.target)) {
                        return;
                    }
                    binding.value(e);
                };
                el._clickOutside = handler;
                document.addEventListener('click', handler);
            },
            unbind(el) {
                document.removeEventListener('click', el._clickOutside);
                delete el._clickOutside;
            }
        }
    },
};
</script>

<style scoped lang="scss">
@import './style/common.scss';
@import './style/material-market.scss';
</style>
